import { createStore, ModuleTree } from "vuex";
import annotation_module from "./modules/annotation_module";
import authentication_module from "./modules/authentication_module";
import categories_module from "./modules/categories_module";
import content_module from "./modules/content/content_module";
import course_module from "./modules/course_module";
import interest_module from "./modules/interest_module";
import miscellany_module from "./modules/miscellany_module";
import userProfile_module from "./modules/userProfile_module";
import statement_module from "./modules/statement_module";
import shop_module from "./modules/shop_module";
import event_module from "./modules/event_module";
import utils_module from "./modules/utils_module";
import globalSearch_module from "./modules/globalSearch_module";
import question_module from "./modules/question_module";
import alert_box_module from "./modules/alert_box_module";
import pill_module from "./modules/pill_module";
import doubt_module from "./modules/doubt_module";
import notification_module from "./modules/notification_module";
import training_course_module from "./modules/training_course_module";
import decoins_module from "./modules/decoins_module";
import information_module from "./modules/information_module";
import list_picker_module from "./modules/list_picker_module";
import suggestion_module from "./modules/suggestion_module";
import configuration_module from "./modules/configuration_module";

/** It serves just to type safety  */
export class RootState {}

const modules: ModuleTree<any> = {
  annotation_module,
  authentication_module,
  userProfile_module,
  categories_module,
  content_module,
  course_module,
  interest_module,
  miscellany_module,
  statement_module,
  shop_module,
  event_module,
  utils_module,
  globalSearch_module,
  question_module,
  alert_box_module,
  doubt_module,
  pill_module,
  notification_module,
  training_course_module,
  decoins_module,
  information_module,
  list_picker_module,
  suggestion_module,
  configuration_module
};

const store = createStore({
  modules
});

const ObjectToArray = obj => {
  return Object.keys(obj).map(function(key) {
    return [Number(key), obj[key]];
  });
};

export const resetStore = () => {
  const modulesList = ObjectToArray(modules);

  modulesList.forEach(module => {
    const classConstructor = module[1].state.constructor;
    module[1].state = new classConstructor();
  });
};

export default store;
